<template>
  <div data-test-id="HelpComponent" class="help">
    <div class="help">
      <b-button pill variant="outline-primary" size="sm" @click="showModal">Help</b-button>
    </div>

    <b-modal id="helpModal" ref="helpModal" size="lg" scrollable centered ok-only :title="helpTitle">
      <slot name="helpContent" />
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "Help",
  props: {
    title: {
      type: String,
      default: "Help"
    }
  },
  data() {
    return {};
  },
  computed: {
    helpTitle() {
      return this.title;
    }
  },
  methods: {
    showModal() {
      this.$refs.helpModal.show();
    }
  }
};
</script>

<style scoped lang="css">
.help {
  position: absolute;
  top: -10px;
  right: 10px;
}
</style>
